var map = {
	"./ourwork1.jpeg": 411,
	"./ourwork10.jpeg": 21,
	"./ourwork11.jpeg": 358,
	"./ourwork12.jpeg": 419,
	"./ourwork2.jpeg": 102,
	"./ourwork3.jpeg": 661,
	"./ourwork4.jpeg": 624,
	"./ourwork5.jpeg": 671,
	"./ourwork6.jpeg": 962,
	"./ourwork7.jpeg": 913,
	"./ourwork8.jpeg": 836,
	"./ourwork9.jpeg": 515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395;